import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2e8cb070")
const _hoisted_1 = { class: "device-name-wrapper" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['device-name'])
}
const _hoisted_3 = { class: "opt-wrapper" }
_popScopeId()

import { computed } from "vue";
import _ from "lodash";

interface DeviceCardProps {
  deviceId: string;
  deviceName: string;
  enabled: boolean;
  online: boolean;
}


export default _defineComponent({
  props: {
    deviceId: { type: String, required: true, default: "" },
    deviceName: { type: String, required: true, default: "未知设备" },
    enabled: { type: Boolean, required: true, default: true },
    online: { type: Boolean, required: true, default: true }
  } as unknown as undefined,
  emits: ["change-device-status"] as unknown as undefined,
  setup(__props: {
  deviceId: string;
  deviceName: string;
  enabled: boolean;
  online: boolean;
}, { emit }: { emit: ({
  (event: "change-device-status", id: string, enabled: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const deviceName = computed<string>(() => props.deviceName);
const deviceEnabled = computed<boolean>(() => props.enabled);
const deviceOnline = computed<boolean>(() => props.online);
const deviceId = computed<string>(() => props.deviceId);

// 修改启用禁用状态
const handleChangeEnable = _.throttle(() => {
  if (deviceOnline.value) {
    emit("change-device-status", deviceId.value, !deviceEnabled.value);
  }
}, 1000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['device-card', _unref(deviceOnline) ? 'online-card' : 'outline-card'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(7 >= _unref(deviceName).length
            ? _unref(deviceName)
            : `${_unref(deviceName).slice(0, 3)}...${_unref(deviceName).slice(
                _unref(deviceName).length - 3,
                _unref(deviceName).length
              )}`), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(['opt-btn', _unref(deviceEnabled) ? 'enabled-btn' : 'disabled-btn']),
        style: _normalizeStyle(
          !_unref(deviceOnline)
            ? { backgroundColor: '#B8BEC3', cursor: 'not-allowed' }
            : {}
        ),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleChangeEnable) && _unref(handleChangeEnable)(...args)))
      }, [
        _createElementVNode("div", null, _toDisplayString(_unref(deviceEnabled) ? "已启用" : "已禁用"), 1)
      ], 6)
    ])
  ], 2))
}
}

})